import styled from 'styled-components';
import {CellValueTextDefaultBox} from './cell-value-text.default.box';

export const CellValueTextCasino777Box = styled(CellValueTextDefaultBox)`
    color: ${props => props.theme.colors.dangerDark};
`;